module.exports = __webpack_public_path__ + "static/media/no-menu.2ca2fa17.png";